<!--English Version-->
<section *ngIf="language === 'en'">
    <div class="container-fluid">
        <h2>Batch Import Providers</h2>
        <br>
        <p>
            The <strong>Import Providers</strong> button on the Provider Directory screen allows you to perform a bulk
            import of providers.
            To use this feature, you will need to create a CSV file with providers' data. The CSV file should have a
            header row with the following columns, and each subsequent row contains data for a Provider.
        </p>
        <p>
            You may use Excel or any other spreadsheet application to edit the CSV file, but be aware of the auto
            formatting behavior of your application. For example, Excel will automatically trim leading zeros in
            numerical columns, and reformat the date column to your locale. When saving the CSV file, make sure to save
            it as a plain-text CSV file.
        </p>
        <p>Refer to <a target="_blank" href="{{document360Url}}" title="Document360">Document360</a> for more
            details on file
            format.&nbsp;<a href="{{sampleFileUrl}}" download title="Download this template as a file">Download file
                sample
                <i class="fas fa-download fa-lg ml-1"></i>
            </a>
        </p>
    </div>
</section>
<!--Spanish Version-->
<section *ngIf="language === 'es'">
    <div class="container-fluid">
        <h2>Importación masiva de proveedores</h2>
        <br>
        <p>
            The <strong>Import Providers</strong> button on the Provider Directory screen allows you to perform a bulk
            import of providers.
            To use this feature, you will need to create a CSV file with providers' data. The CSV file should have a
            header row with the following columns, and each subsequent row contains data for a Provider.
        </p>
        <p>
            Podrá usar Excel o cualquier otra hoja de cálculo para editar el archivo CSV, pero deberá prestar atención a
            las opciones de autoformato de su aplicación. Por ejemplo, Excel eliminará todo los ceros que encuentre a la
            izquieda en las columnas numéricas y formateará las columnas de fecha al formato local que tenga definido.
            Cuando grabe el archivo CSV asegúrese de grabarlo como un archivo CSV de texto plano.
        </p>
        <p>Consulte <a target="_blank" href="{{document360Url}}" title="Document360">Document360</a> para
            obtener más detalles
            sobre el formato de archivo.&nbsp;<a href="{{sampleFileUrl}}" download
                title="Descargue esta plantilla como archivo">Descargar archivo de
                muestra
                <i class="fas fa-download fa-lg ml-1"></i>
            </a>
        </p>
    </div>
</section>
<!--German Version - TODO-->
<section *ngIf="language === 'de'">
    <div class="container-fluid">
        <h2>Batch Import Providers</h2>
        <br>
        <p>
            The <strong>Import Providers</strong> button on the Provider Directory screen allows you to perform a bulk
            import of providers.
            To use this feature, you will need to create a CSV file with providers' data. The CSV file should have a
            header row with the following columns, and each subsequent row contains data for a Provider.
        </p>
        <p>
            You may use Excel or any other spreadsheet application to edit the CSV file, but be aware of the auto
            formatting behavior of your application. For example, Excel will automatically trim leading zeros in
            numerical columns, and reformat the date column to your locale. When saving the CSV file, make sure to save
            it as a plain-text CSV file.
        </p>
        <p>Refer to <a target="_blank" href="{{document360Url}}" title="Document360">Document360</a> for more
            details on file
            format.&nbsp;<a href="{{sampleFileUrl}}" download title="Download this template as a file">Download file
                sample
                <i class="fas fa-download fa-lg ml-1"></i>
            </a>
        </p>
    </div>
</section>